import ReactModal from "react-modal";

import styles from "./ConfirmActionModal.module.css";
import Icon from "../Icon/Icon";

type ConfirmActionModalPropsType = {
  isOpen: boolean;
  onRequestClose: () => void;
  modalTitle: string;
  modalText: string;
  cancelActionText: string;
  cancelActionHandler: () => void;
  confirmActionText: string;
  confirmActionHandler: () => void;
};

const ConfirmActionModal = ({
  isOpen,
  onRequestClose,
  modalTitle,
  modalText,
  cancelActionText,
  cancelActionHandler,
  confirmActionText,
  confirmActionHandler,
}: ConfirmActionModalPropsType) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <h4 className={styles.modalTitle}>{modalTitle}</h4>
      <p className={styles.modalText}>{modalText}</p>
      <div className={styles.buttonsContainer}>
        <button onClick={cancelActionHandler} className={styles.cancelButton}>
          {cancelActionText}
        </button>
        <button onClick={confirmActionHandler} className={styles.confirmButton}>
          {confirmActionText}
        </button>
      </div>
      <button className={styles.closeIcon} onClick={onRequestClose}>
        <Icon name="x-mark" size={16} />
      </button>
    </ReactModal>
  );
};

export default ConfirmActionModal;
